declare const WEBPACK_VAR_VERSION_FULL: string

export const versionFull = WEBPACK_VAR_VERSION_FULL
